"use client";

import { motion } from "framer-motion";

import Image from "@/app/_components/Image";
import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";
import { DEFAULT_DURATION } from "@/lib/animation";

import styles from "./HistorySection.module.scss";

const images = [
  {
    desktop: `/fifa/fifa-marquee-1.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-1-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    desktop: `/fifa/fifa-marquee-2.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-2-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    desktop: `/fifa/fifa-marquee-3.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-3-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    desktop: `/fifa/fifa-marquee-4.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-4-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    desktop: `/fifa/fifa-marquee-5.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-5-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    desktop: `/fifa/fifa-marquee-6.webp?v=${FIFA_ASSET_VERSION}`,
    mobile: `/fifa/fifa-marquee-6-mb.webp?v=${FIFA_ASSET_VERSION}`,
  },
];

const marqueeImages = [...images, ...images];

export default function HistorySection() {
  return (
    <section className={styles.section}>
      <div className={styles.card}>
        {/* BG IMAGE */}
        <div className={styles.bg} />

        {/* DARK OVERLAY */}
        <div className={styles.overlay} />

        {/* CONTENT */}
        <div className={styles.content}>
          <motion.div
            className={styles.textBox}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.3,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.18,
                },
              },
            }}
          >
            <motion.h2
              className={styles.title}
              variants={{
                hidden: {
                  opacity: 0,
                  y: 40,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
              transition={{
                duration: DEFAULT_DURATION,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            >
              A Long Journey with FIFA
            </motion.h2>

            <motion.p
              className={styles.text}
              variants={{
                hidden: {
                  opacity: 0,
                  y: 32,
                },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
              transition={{
                duration: DEFAULT_DURATION,
                ease: [0.25, 0.1, 0.25, 1],
              }}
            >
              Since 2010, as an official FIFA partner,
              Kia has stood alongside the passion of
              football fans around the world.

              To help this global celebration reach more
              people, Kia has supported tournament
              operations and mobility in efficient and
              responsible ways.

              Building on this experience, Kia continues
              to work with FIFA to help shape the future
              of sustainable mobility.
            </motion.p>
          </motion.div>

          {/* MARQUEE */}
          <motion.div
            className={styles.marquee}
            initial={{
              opacity: 0,
              y: 60,
            }}
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            viewport={{
              once: true,
              amount: 0.2,
            }}
            transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1],
            }}
          >
            <div className={styles.track}>
              {marqueeImages.map((image, index) => (
                <div
                  className={styles.item}
                  key={index}
                >
                  <picture>
                    <source
                      media="(max-width: 767px)"
                      srcSet={image.mobile}
                    />

                    <Image
                      src={image.desktop}
                      alt="History"
                      width={420}
                      height={340}
                      loading="lazy"
                      quality={65}
                      draggable={false}
                  />
                  </picture>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}